import { createSlice } from "@reduxjs/toolkit";

interface IntialStateInterface {
  menuTypes: any[];
  loading: boolean;
  error: any;
}

const initialState: IntialStateInterface = {
  menuTypes: [],
  loading: false,
  error: null,
};

const menuTypeSlice = createSlice({
  name: "menuType",
  initialState,
  reducers: {
    getMenuTypesStart(state) {
      state.loading = true;
      state.error = null;
    },
    getMenuTypesSuccess(state, action) {
      state.menuTypes = action.payload;
      state.loading = false;
      state.error = null;
    },
    getMenuTypesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { getMenuTypesStart, getMenuTypesSuccess, getMenuTypesFailure } =
  menuTypeSlice.actions;

export default menuTypeSlice.reducer;
